import React from "react";
import { Link } from "react-router-dom";

export default function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-[#EEF1F7] flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-md">
          <div className="text-center mb-6">
            <Link to="/" data-testid="authshell-home-link" className="inline-flex flex-col items-center gap-2 hover:opacity-80 transition-opacity">
              <img src="/fydate-icon.png" alt="FYDATE" className="w-16 h-16 rounded-2xl object-cover shadow-sm" />
              <span className="font-serif text-3xl font-bold text-[#141A3A]">FYDATE</span>
            </Link>
            <p className="text-[#4A4E68] mt-1">La bacheca dei bisogni</p>
          </div>
          <div className="bg-white rounded-[18px] border border-[#DADFEA] p-6 shadow-sm fade-in">
            <h2 className="font-serif text-2xl font-semibold text-[#0F1230] mb-1">{title}</h2>
            {subtitle && <p className="text-sm text-[#4A4E68] mb-4">{subtitle}</p>}
            {children}
          </div>
          <p className="text-center text-sm text-[#4A4E68] mt-6">FYDATE — La bacheca dei bisogni</p>
        </div>
      </div>
    </div>
  );
}
